export default "__VITE_ASSET__DX3xK0m___"